export default __webpack_public_path__ + "static/media/4B378B05-AEE8-4655-BA6F-075E74B78E79_1_105_c.485bc2f1.jpeg";